import React                    from 'react';
import { Observe }              from 'rewire-core';
import {
  WithStyle,
  FormView
}                               from 'rewire-ui';
import { Theme }                from '@material-ui/core/styles';
import DraggableResizableDialog from '../ui/DraggableResizableDialog';
import addAreaDialogModel       from './AddAreaDialogModel';
import { withStyles }           from '../utility/styles';


const styles = (_theme: Theme) => ({
});

interface IAddAreaDialogProps {
}

type AddAreaDialogProps = WithStyle<ReturnType<typeof styles>, IAddAreaDialogProps>;

class AddAreaDialog extends React.PureComponent<AddAreaDialogProps> {
  constructor(props: AddAreaDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    addAreaDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={addAreaDialogModel.form} onSubmit={addAreaDialogModel.actionFn('save')}>
        <div className='content'>
          <addAreaDialogModel.form.field.name.Editor className='span1' />
        </div>
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: addAreaDialogModel}} DraggableResizableBoxProps={{minWidth: '260px', minHeight: '213px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IAddAreaDialogProps>(styles, AddAreaDialog);
